"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ga4 = void 0;
var _ookies_1 = require("@app/util/\u0441ookies");
// const cookieGA: any = {
//   _ga: 'GA1.2.1045174256.1721560491',
//   _ga_DBD5564S29: 'GS1.1.1721560490.1.1.1721560897.52.0.0'
// }
/* using for testing
// $biTracking->setGAApiKey('htYxW-NuSGi_pZ5NnnKYMg');
// $biTracking->setGAMeasurementId('G-DBD5564S29');

// data-ga_api_key="htYxW-NuSGi_pZ5NnnKYMg" data-ga_measurement_id="G-DBD5564S29" data-ga_session_id="1721551281" data-ga_client_id="1502395557.1721551281">  </script>
*/
var cookieGA = {};
var Ga4 = /** @class */ (function () {
    function Ga4(apiKey, measurementId) {
        this.apiKey = apiKey;
        this.measurementId = measurementId;
        this.cookies = new _ookies_1.Cookies();
    }
    Ga4.prototype.getSessionKey = function () {
        var measurementId = this.measurementId.substring(2);
        return "_ga_".concat(measurementId);
    };
    Ga4.prototype.getSessionId = function () {
        var value = this.cookies.get(this.getSessionKey()) || cookieGA[this.getSessionKey()];
        try {
            value = value.split('.')[2];
            return parseInt(value);
        }
        catch (err) {
            console.warn('Error getSessionId', err);
            return;
        }
    };
    Ga4.prototype.getClientId = function () {
        var CLIENT_ID_COOKIE_NAME = '_ga';
        var value = this.cookies.get(CLIENT_ID_COOKIE_NAME) || cookieGA[CLIENT_ID_COOKIE_NAME];
        try {
            return value.split('.').slice(2).join('.');
        }
        catch (err) {
            console.warn('Error getClientId', err);
            return '';
        }
    };
    Ga4.prototype.get = function () {
        return {
            api_key: this.apiKey,
            session_id: this.getSessionId(),
            measurement_id: this.measurementId,
            client_id: this.getClientId(),
        };
    };
    return Ga4;
}());
exports.Ga4 = Ga4;
